export const ENDPOINT = (slug: string) => `api/app/merchants/${slug}/available-schedule`;

export type AvailableScheduleSlot = {
  start: string; // horário de início (ex: "18:30")
  end: string; // horário de fim (ex: "18:45")
};

export type AvailableScheduleDay = {
  date: string; // data no formato YYYY-MM-DD (ex: "2025-10-30")
  day_of_week: number; // dia da semana (0-6)
  day_name: string; // nome do dia (ex: "Quinta-feira")
  is_today: boolean; // se é hoje
  is_tomorrow: boolean; // se é amanhã
  slots: AvailableScheduleSlot[]; // lista de horários disponíveis
};

export type ScheduleInactive = {
  status: string; // status da resposta (ex: "success")
  scheduling_enabled: false; // sempre false quando agendamento está desativado
  has_availability: false; // se há disponibilidade (quando não temos horários disponíveis)
  message: string; // mensagem explicando por que o agendamento não está disponível
};

export type ScheduleActive = {
  status: string; // status da resposta (ex: "success")
  available_schedule: AvailableScheduleDay[] | []; // lista de dias disponíveis
  schedule_days_ahead: number; // quantos dias à frente estão disponíveis
  scheduling_enabled: true; // sempre true quando agendamento está ativado
  has_availability: boolean; // se há disponibilidade (quando temos horários disponíveis)
};

export type GetAvailableScheduleResponse = ScheduleInactive | ScheduleActive;
